module.exports = __webpack_public_path__ + "static/media/50.c871797a.png";